<template>
  <div id="app" v-cloak>
    <router-view></router-view>
  </div>
</template>

<script>
import store from '@/store';
import { EventBus } from '@/services/EventBus';

export default {
  name: 'App',
  methods: {
    onResize() {
      EventBus.$emit('window-resize');
    }
  },
  mounted() {
    store.dispatch('map/loadStaticData');

    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }
}
</script>

<style lang="stylus">
@import '../static/styl/customized-select.styl'
@import '../static/styl/rich-text.styl'
@import '../static/styl/coverage-overlay.styl'

#app
  font-family "Open Sans", sans-serif
  font-size 16px
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  color #333
  min-height 100%
  position relative

html, body
  margin 0
  padding 0
  box-sizing border-box
  font-size 10px

body, html
  height 100%

body
  font-size 1.6rem
  overflow-y scroll

</style>



// WEBPACK FOOTER //
// src/App.vue